import React, { useState } from 'react';
import { spanBaseStyle, spanLineThroughStyle, spanRedStyle, titleMarginLeftStyle, titlePaddingRightStyle } from './CondensedMobileViewList.styles';
import { setItemLoader } from 'src/pages/equity/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { TITLE_FONT_COLOR,SEMANTIC_TEXT_PX, GREY_PRODUCT_LIST_COLOR, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import CondensedMobileView from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileView';
import { Text, BundlePriceDiv, Title, Title2 } from './CondensedMobileView.styled';
import { useTranslation } from 'react-i18next';
import { Header } from './CondensedMobileViewItem.styled';
import { setCurrencyFormatWithoutSymbol, getCurrencySymbol, logErrorToConsole } from 'src/utils/util';
import CondensedMobileViewSets from './CondensedMobileViewSets';
import CondensedMobileViewFees from './CondensedMobileViewFees';
import CondensedMobileViewItem from './CondensedMobileViewItem';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const CondensedMobileViewList = ({
    section,
    product = [],
    handleSetItemClick = () => {},
    removeCounter = () => {},
    setsQuantityCheck = () => {},
    addCounter = () => {},
    cartPage,
    isEquityTemp,
    isShippingScreen = false,
    isReviewSubmitScreen = false,
    isOrderScreen = false,
    inventoryShipping = false,
    handleLocationChange = () => {},
    checkAll = false,
    checked,
    marginSets,
    itemCardsContainerMinMobWidthSets,
    minWidthSets,
    marginOnMediumDeviceSets,
    marginOnLargeDeviceSets,
    marginOnMobileDeviceSets,
    checkSelectAllDisabled = () => {},
    selectAllDisabled = '',
    handleShipAllChange = () => {},
    selectedLocation,
    isBatchSelected,
    setIsBatchSelected,
    showCheckBox = true,
    tab,
    deleteProduct = () => {},
    onBomClick = () => {},
    isEquity = false,
    isQuickOrder = false,
    isTemplateDetail = false,
    isFromSurgeryTemplate = false,
    isConsignmentAdd,
    isSurgery,
    isReviewSubmitScreenEquity,
    reviewScreen = false,
    isOrderDetailTab = false,
    expandedProducts,
    toggleProduct = () => {},
    isCartScreenOrProductGuide = false,
    handleSetSelection = () => {},
    isExtraItem,
    isFromConsignmentAdd = false,
    addInstrumentCounter = () => {},
    handleBundlePopup = () => {},
    expandedProductsItemList,
    toggleProductItemList = () => {},
    isBundleChildren,
    orderType = '',
    isEquityTemplate = false,
    implantShipAll,
    instrumentShipAll,
    isCondensedView = false,
    moreTemplates = false,
    isFromTemplates = false,
    isQuickOrderEquityTemplate = false,
    handleBundleSetItemClick = () => {},
    updateProductQuantity = () => {},
    minHeight,
    marginRight,
    isEquityTemplateBundlePopup = false,
    onEmptyCategory,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [setImplant, setSetImplant] = useState([]);
    const [setInstrument, setSetInstrument] = useState([]);
    const [itemImplant, setItemImplant] = useState([]);
    const [itemInstrument, setItemInstrument] = useState([]);
    const [feesImplant, setFeesImplant] = useState([]);
    const [feesInstrument, setFeesInstrument] = useState([]);
    const [bundles, setBundles] = useState([]);
    const [backgroundColorCode, setBackgroundColorCode] = useState(
        '#ffffff 0% 0% no-repeat padding-box'
    );
    const [bundleChildrenFlag, setBundleChildrenFlag] = useState('');
    const { products } = useSelector((state) => ({
        products: state.surgeryReducer.cartData.products,
    }));
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );

    const {
        cartProducts,
    } = useSelector((state) => ({
        cartProducts: state.surgeryReducer.cartData.products,
    }));
    useEffectWithErrorLogging(() => {
        if (!isOrderDetailTab) {
            let setsImplants = [];
            let setsInstruments = [];
            let itemsImplants = [];
            let itemsInstruments = [];
            let feesImplants = [];
            let feesInstruments = [];
            let bundle = [];
            let productsCopy = [...(product || [])];
            if (moreTemplates) {
                productsCopy = productsCopy.filter(
                    (item) => !item?.isTemplateEntryDeleted
                );
            }
            productsCopy = productsCopy?.sort((a, b) =>
                (a?.productCFN || a?.cfn || '').localeCompare(
                    b?.productCFN || b?.cfn || ''
                )
            );
            productsCopy?.length > 0 &&
                productsCopy
                    .filter((item) => {
                        return Object.keys(item).length > 0;
                    })
                    .map((e) => {
                        if (e.isSet) {
                            if (e.implantable) {
                                setsImplants.push(e);
                            } else {
                                setsInstruments.push(e);
                            }
                        } else if (e.materialType == 'DIEN') {
                            if (e.implantable) {
                                feesImplants.push(e);
                            } else {
                                feesInstruments.push(e);
                            }
                        } else if (
                            e.materialType == 'ZKMT' ||
                            (e.bundleItems?.length > 0 &&
                                Object.prototype.hasOwnProperty.call(
                                    e,
                                    'bundleItems'
                                ))
                        ) {
                            bundle.push(e);
                        } else {
                            if (e.implantable) {
                                itemsImplants.push(e);
                            } else {
                                itemsInstruments.push(e);
                            }
                        }
                    });
            setSetImplant(setsImplants);
            setSetInstrument(setsInstruments);
            setItemImplant(itemsImplants);
            setItemInstrument(itemsInstruments);
            setFeesImplant(feesImplants);
            setFeesInstrument(feesInstruments);
            setBundles(bundle);
        }

        if (isOrderDetailTab) {
            let itemsImplants = [];
            let itemsInstruments = [];
            product?.length > 0 &&
                product.map((e) => {
                    if (e.isSet) {
                        e.productMoreDetails?.billOfMaterials?.length > 0 &&
                            e.productMoreDetails?.billOfMaterials.map(
                                (item) => {
                                    if (item.isImplantable) {
                                        itemsImplants.push(item);
                                    } else {
                                        itemsInstruments.push(item);
                                    }
                                }
                            );
                    }
                    if (!e.isSet) {
                        if (e.isImplantable) {
                            itemsImplants.push(e);
                        } else {
                            itemsInstruments.push(e);
                        }
                    }
                });
            setItemImplant(itemsImplants);
            setItemInstrument(itemsInstruments);
        }
    }, [product, product?.length]);

    useEffectWithErrorLogging(() => {
        const timer = setTimeout(() => {
            try {
                dispatch(setItemLoader(false));
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 1500);

        return () => clearTimeout(timer);
    }, [product]);

    return (
        <>
            {(tab == 'sets' || reviewScreen) && (
                <CondensedMobileViewSets
                    setImplant={setImplant}
                    setInstrument={setInstrument}
                    section={section}
                    cartPage={cartPage}
                    isOrderDetailTab={isOrderDetailTab}
                    t={t}
                    isOrderScreen={isOrderScreen}
                    reviewScreen={reviewScreen}
                    cartProducts={cartProducts}
                    isShippingScreen={isShippingScreen}
                    showCheckBox={showCheckBox}
                    shipDontShipSurgery={shipDontShipSurgery}
                    isCondensedView={isCondensedView}
                    implantShipAll={implantShipAll}
                    checkAll={checkAll}
                    checkSelectAllDisabled={checkSelectAllDisabled}
                    countryISOCode={countryISOCode}
                    selectAllDisabled={selectAllDisabled}
                    handleShipAllChange={handleShipAllChange}
                    inventoryShipping={inventoryShipping}
                    expandedProducts={expandedProducts}
                    expandedProductsItemList={expandedProductsItemList}
                    toggleProduct={toggleProduct}
                    toggleProductItemList={toggleProductItemList}
                    isEquityTemp={isEquityTemp}
                    orderType={orderType}
                    handleSetItemClick={handleSetItemClick}
                    removeCounter={removeCounter}
                    addCounter={addCounter}
                    setsQuantityCheck={setsQuantityCheck}
                    products={products}
                    handleLocationChange={handleLocationChange}
                    checked={checked}
                    isBatchSelected={isBatchSelected}
                    setIsBatchSelected={setIsBatchSelected}
                    selectedLocation={selectedLocation}
                    deleteProduct={deleteProduct}
                    onBomClick={onBomClick}
                    handleSetSelection={handleSetSelection}
                    isReviewSubmitScreen={isReviewSubmitScreen}
                    isTemplateDetail={isTemplateDetail}
                    isFromTemplates={isFromTemplates}
                    instrumentShipAll={instrumentShipAll}
                    isSurgery={isSurgery}
                    isConsignmentAdd={isConsignmentAdd}
                    isEquityTemplate={isEquityTemplate}
                    isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                    marginRight={marginRight}
                    isQuickOrder={isQuickOrder}
                    onEmptyCategory={onEmptyCategory}
                />
            )}
            {(tab == 'item' || reviewScreen) && (
                <CondensedMobileViewItem
                    itemImplant={itemImplant}
                    itemInstrument={itemInstrument}
                    section={section}
                    cartPage={cartPage}
                    isFromConsignmentAdd={isFromConsignmentAdd}
                    isOrderDetailTab={isOrderDetailTab}
                    t={t}
                    isOrderScreen={isOrderScreen}
                    showCheckBox={showCheckBox}
                    isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                    expandedProducts={expandedProducts}
                    expandedProductsItemList={expandedProductsItemList}
                    toggleProduct={toggleProduct}
                    toggleProductItemList={toggleProductItemList}
                    isEquityTemp={isEquityTemp}
                    isEquity={isEquity}
                    isFromEquity={isEquity}
                    isQuickOrder={isQuickOrder}
                    orderType={orderType}
                    handleSetItemClick={handleSetItemClick}
                    removeCounter={removeCounter}
                    addCounter={addCounter}
                    setsQuantityCheck={setsQuantityCheck}
                    products={products}
                    handleLocationChange={handleLocationChange}
                    checked={checked}
                    isBatchSelected={isBatchSelected}
                    setIsBatchSelected={setIsBatchSelected}
                    selectedLocation={selectedLocation}
                    deleteProduct={deleteProduct}
                    onBomClick={onBomClick}
                    handleSetSelection={handleSetSelection}
                    isReviewSubmitScreen={isReviewSubmitScreen}
                    isTemplateDetail={isTemplateDetail}
                    instrumentShipAll={instrumentShipAll}
                    isSurgery={isSurgery}
                    isConsignmentAdd={isConsignmentAdd}
                    isEquityTemplate={isEquityTemplate}
                    isExtraItem={isExtraItem}
                    reviewScreen={reviewScreen}
                    isShippingScreen={isShippingScreen}
                    minHeight={minHeight}
                    updateProductQuantity={updateProductQuantity}
                    isFromSurgeryTemplate={isFromSurgeryTemplate}
                    isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                    inventoryShipping={inventoryShipping}
                    marginRight={marginRight}
                    isQuickOrderEquityTemplate={isQuickOrderEquityTemplate}
                    isEquityTemplateBundlePopup={isEquityTemplateBundlePopup}
                    onEmptyCategory={onEmptyCategory}
                />
            )}
            {(isEquity && tab === 'item' ) 
            || (!((isEquity || isOrderScreen)  && ((tab === 'fees') || (tab === 'sets'))))?
            (bundles?.length > 0) && (
                <>
                    {bundles?.length > 0 && (
                        <Header
                            mbMarginTop={'0px'}
                        >
                            {'Bundle'} ({bundles?.length})
                        </Header>
                    )}

                    {bundles?.length > 0 &&
                        bundles?.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    style={{ width: '100%' }}
                                >
                                    <CondensedMobileView
                                        isSurgery={isSurgery}
                                        isEquityTemplate={
                                            isEquityTemplate
                                        }
                                        orderType={orderType}
                                        showCheckBox={showCheckBox}
                                        isOrderDetailTab={
                                            isOrderDetailTab
                                        }
                                        isCartScreenOrProductGuide={
                                            isCartScreenOrProductGuide
                                        }
                                        onToggle={() =>
                                            isOrderScreen
                                                ? isOrderDetailTab
                                                    ? toggleProductItemList(
                                                            item?.productKey
                                                        )
                                                    : toggleProduct(
                                                            item?.productKey
                                                        )
                                                : toggleProduct(
                                                        item?.productKey
                                                    )
                                        }
                                        isExpanded={
                                            isOrderScreen
                                                ? isOrderDetailTab
                                                    ? expandedProductsItemList?.has(
                                                            item?.productKey
                                                        )
                                                    : expandedProducts?.has(
                                                            item?.productKey
                                                        )
                                                : expandedProducts?.has(
                                                        item?.productKey
                                                    )
                                        }
                                        cartPage={cartPage}
                                        isEquityTemp={isEquityTemp}
                                        marginOnMediumDevice={marginOnMediumDeviceSets}
                                        marginOnLargeDevice={marginOnLargeDeviceSets}
                                        marginOnMobileDevice={marginOnMobileDeviceSets}
                                        key={`${item.cfn}-${0}`}
                                        isCounterButton={true}
                                        minWidth={minWidthSets}
                                        setOrItemDetails={item}
                                        removeCount={() =>
                                            item?.quantity > 0 &&
                                            removeCounter(
                                                item?.cfn,
                                                false,
                                                item
                                            )
                                        }
                                        addCount={() =>
                                            addCounter(item, item.cfn)
                                        }
                                        cardType={'items'}
                                        count={item.count}
                                        showBrand={true}
                                        showType={true}
                                        margin={marginSets}
                                        setNameColor={TITLE_FONT_COLOR}
                                        setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                                        setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                                        itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidthSets}
                                        onSetItemClick={
                                            handleSetItemClick
                                        }
                                        clickable={true}
                                        basePrice={item?.basePrice}
                                        extPrice={item?.extPrice}
                                        productSearchFlag={true}
                                        productType={'Cart'}
                                        isCart={true}
                                        setIsQuantityMoreThan50={true}
                                        description={item.description}
                                        background={
                                            index % 2 !== 0
                                                ? GREY_PRODUCT_LIST_COLOR
                                                : ''
                                        }
                                        section={section}
                                        isEquity={isEquity}
                                        isTemplateDetail={
                                            isTemplateDetail
                                        }
                                        isFromSurgeryTemplate={
                                            isFromSurgeryTemplate
                                        }
                                        deleteProduct={deleteProduct}
                                        isConsignmentAdd={
                                            isConsignmentAdd
                                        }
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        inventoryShipping={
                                            inventoryShipping
                                        }
                                        handleSetSelection={
                                            handleSetSelection
                                        }
                                        isReviewSubmitScreen={
                                            isReviewSubmitScreen
                                        }
                                        isOrderScreen={isOrderScreen}
                                        setBundleChildrenFlag={
                                            setBundleChildrenFlag
                                        }
                                        isFromBundle={true}
                                        isQuickOrder={isQuickOrder}
                                        updateProductQuantity={
                                            updateProductQuantity
                                        }
                                    />
                                    {
                                        <Text
                                            padding={
                                                expandedProducts?.has(
                                                    item?.productKey
                                                )
                                                    ? '10px 23px'
                                                    : '10px 11px'
                                            }
                                            background={
                                                index % 2 !== 0
                                                    ? GREY_PRODUCT_LIST_COLOR
                                                    : ''
                                            }
                                            style={{
                                                borderBottom:
                                                    !expandedProducts?.has(
                                                        item?.productKey
                                                    ) &&
                                                    '1px solid lightgray',
                                            }}
                                            isExpanded={expandedProducts?.has(item?.productKey)}
                                            isBundlesChildren={true}
                                        >
                                            <Title
                                                style={titleMarginLeftStyle}
                                            >
                                                In Bundle{': '}
                                                {item?.children?.filter((d)=>!d?.isTemplateEntryDeleted)
                                                    ?.length ||
                                                    item?.bundleItems?.filter((d)=>!d?.isTemplateEntryDeleted)
                                                        ?.length}
                                            </Title>
                                            {cartPage &&
                                                expandedProducts?.has(
                                                    item?.productKey
                                                ) && (
                                                    <Title
                                                        fontSize={
                                                            SMALL_TEXT_PX
                                                        }
                                                        color={
                                                            TITLE_FONT_COLOR
                                                        }
                                                        onClick={() => {
                                                            handleBundlePopup(
                                                                item
                                                            );
                                                            handleBundleSetItemClick(
                                                                item
                                                            );
                                                        }}
                                                        style={titlePaddingRightStyle}
                                                    >
                                                        {t(
                                                            'equity.common.bundleItems.additemsBundle'
                                                        )}
                                                    </Title>
                                                )}
                                        </Text>
                                    }
                                    {expandedProducts?.has(
                                        item?.productKey
                                    ) &&
                                        (item?.children?.length > 0 ||
                                            item?.bundleItems?.length >
                                                0) &&
                                        (
                                            item?.children ||
                                            item?.bundleItems
                                        )
                                            ?.filter(
                                                (item) =>
                                                    !item?.isTemplateEntryDeleted
                                            )
                                            .map(
                                                (
                                                    childItem,
                                                    childIndex
                                                ) => {
                                                    return (
                                                        <div
                                                            key={
                                                                childIndex
                                                            }
                                                        >
                                                            <CondensedMobileView   
                                                                isSurgery={isSurgery}
                                                                isChildItem={
                                                                    true
                                                                }
                                                                productKeyBundle={
                                                                    item?.productKey
                                                                }
                                                                isEquityTemplate={
                                                                    isEquityTemplate
                                                                }
                                                                orderType={
                                                                    orderType
                                                                }
                                                                showCheckBox={
                                                                    showCheckBox
                                                                }
                                                                isOrderDetailTab={
                                                                    isOrderDetailTab
                                                                }
                                                                onToggle={() =>
                                                                    isOrderScreen
                                                                        ? isOrderDetailTab
                                                                            ? toggleProductItemList(
                                                                                    childItem?.productKey
                                                                                )
                                                                            : toggleProduct(
                                                                                    childItem?.productKey
                                                                                )
                                                                        : toggleProduct(
                                                                                childItem?.productKey
                                                                            )
                                                                }
                                                                isExpanded={
                                                                    isOrderScreen
                                                                        ? isOrderDetailTab
                                                                            ? expandedProductsItemList?.has(
                                                                                    item?.productKey
                                                                                )
                                                                            : expandedProducts?.has(
                                                                                    item?.productKey
                                                                                )
                                                                        : expandedProducts?.has(
                                                                                childItem?.productKey
                                                                            )
                                                                }
                                                                cartPage={
                                                                    cartPage
                                                                }
                                                                isEquityTemp={
                                                                    isEquityTemp
                                                                }
                                                                marginOnMediumDevice={marginOnMediumDeviceSets}
                                                                marginOnLargeDevice={marginOnLargeDeviceSets}
                                                                marginOnMobileDevice={marginOnMobileDeviceSets}
                                                                key={`${
                                                                    childItem.cfn
                                                                }-${0}`}
                                                                isCounterButton={
                                                                    true
                                                                }
                                                                minWidth={
                                                                    minWidthSets
                                                                }
                                                                setOrItemDetails={
                                                                    childItem
                                                                }
                                                                removeCount={() =>
                                                                    childItem?.quantity >
                                                                        0 &&
                                                                    removeCounter(
                                                                        childItem?.productKey,
                                                                        true,
                                                                        childItem,
                                                                        'Bundle',
                                                                        item?.productKey
                                                                    )
                                                                }
                                                                addCount={() =>
                                                                    addCounter(
                                                                        childItem,
                                                                        childItem?.productKey,
                                                                        'bundle',
                                                                        item?.productKey
                                                                    )
                                                                }
                                                                cardType={
                                                                    'items'
                                                                }
                                                                count={
                                                                    childItem?.count
                                                                }
                                                                showBrand={
                                                                    true
                                                                }
                                                                showType={
                                                                    true
                                                                }
                                                                margin={marginSets}
                                                                setNameColor={TITLE_FONT_COLOR}
                                                                setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                                                                setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                                                                itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidthSets}
                                                                onSetItemClick={
                                                                    handleSetItemClick
                                                                }
                                                                clickable={
                                                                    true
                                                                }
                                                                basePrice={
                                                                    false
                                                                }
                                                                extPrice={
                                                                    false
                                                                }
                                                                productSearchFlag={
                                                                    true
                                                                }
                                                                productType={
                                                                    'Cart'
                                                                }
                                                                isCart={
                                                                    true
                                                                }
                                                                setIsQuantityMoreThan50={
                                                                    true
                                                                }
                                                                description={
                                                                    childItem?.description
                                                                }
                                                                background={
                                                                    index %
                                                                        2 !==
                                                                    0
                                                                        ? GREY_PRODUCT_LIST_COLOR
                                                                        : ''
                                                                }
                                                                section={
                                                                    section
                                                                }
                                                                isEquity={
                                                                    isEquity
                                                                }
                                                                isTemplateDetail={
                                                                    isTemplateDetail
                                                                }
                                                                isFromSurgeryTemplate={
                                                                    isFromSurgeryTemplate
                                                                }
                                                                deleteProduct={() =>
                                                                    deleteProduct(
                                                                        childItem,
                                                                        'Bundle',
                                                                        item?.productKey
                                                                    )
                                                                }
                                                                isConsignmentAdd={
                                                                    isConsignmentAdd
                                                                }
                                                                handleLocationChange={
                                                                    handleLocationChange
                                                                }
                                                                inventoryShipping={
                                                                    inventoryShipping
                                                                }
                                                                handleSetSelection={
                                                                    handleSetSelection
                                                                }
                                                                isReviewSubmitScreen={
                                                                    isReviewSubmitScreen
                                                                }
                                                                isOrderScreen={
                                                                    isOrderScreen
                                                                }
                                                                isBundlesChildren={
                                                                    true
                                                                }
                                                                isExpandedBundle={
                                                                    true
                                                                }
                                                                isLastItem={
                                                                    item
                                                                        ?.children
                                                                        ?.length -
                                                                        1 ===
                                                                        childIndex ||
                                                                    item
                                                                        ?.bundleItems
                                                                        ?.length -
                                                                        1 ===
                                                                        childIndex
                                                                }
                                                                updateProductQuantity={
                                                                    updateProductQuantity
                                                                }
                                                                childItemProductkey={
                                                                    childItem?.productKey
                                                                }
                                                            />
                                                        </div>
                                                    );
                                                }
                                            )}
                                    {expandedProducts?.has(
                                        item?.productKey
                                    ) && (
                                        <BundlePriceDiv
                                            background={
                                                index % 2 !== 0
                                                    ? GREY_PRODUCT_LIST_COLOR
                                                    : ''
                                            }
                                        >
                                            {item?.basePrice ? (
                                                <div>
                                                    <Title2>
                                                        {`${t(
                                                            'common.tableView.unitPrice'
                                                        )} ${getCurrencySymbol(
                                                            localStorage.getItem(
                                                                'currencyISOCode'
                                                            )
                                                        )}`}
                                                        :
                                                    </Title2>
                                                    <span
                                                        style={
                                                            item?.adjustedPrice
                                                                ? spanLineThroughStyle
                                                                : spanBaseStyle
                                                        }
                                                    >
                                                        {setCurrencyFormatWithoutSymbol(
                                                            item?.basePrice
                                                        )}
                                                    </span>
                                                    <span> </span>
                                                    {item?.adjustedPrice && (
                                                        <span
                                                            style={spanRedStyle}
                                                        >
                                                            {' '}
                                                            {setCurrencyFormatWithoutSymbol(
                                                                item?.adjustedPrice
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}

                                            {item?.extPrice ? (
                                                <div>
                                                    <Title2>
                                                        {`${t(
                                                            'common.tableView.extPrice'
                                                        )} ${getCurrencySymbol(
                                                            localStorage.getItem(
                                                                'currencyISOCode'
                                                            )
                                                        )}`}
                                                        :
                                                    </Title2>
                                                    <span
                                                        style={
                                                            item?.adjustedExtPrice
                                                                ? spanLineThroughStyle
                                                                : spanBaseStyle
                                                        }
                                                    >
                                                        {' '}
                                                        {setCurrencyFormatWithoutSymbol(
                                                            item?.extPrice
                                                        )}
                                                    </span>
                                                    <span> </span>
                                                    {item?.adjustedExtPrice && (
                                                        <span
                                                            style={spanRedStyle}
                                                        >
                                                            {setCurrencyFormatWithoutSymbol(
                                                                item?.adjustedExtPrice
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            {item?.discount ? (
                                                <div>
                                                    <span
                                                        style={spanRedStyle}
                                                    >
                                                        {' '}
                                                        {
                                                            item?.discount
                                                        }{' '}
                                                        {t(
                                                            'common.discount'
                                                        )}
                                                    </span>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </BundlePriceDiv>
                                    )}
                                </div>
                            );
                        })}
                </>
            ):''}
            {(tab == 'fees' || reviewScreen) && (
                <CondensedMobileViewFees
                    feesImplant={feesImplant}
                    feesInstrument={feesInstrument}
                    section={section}
                    cartPage={cartPage}
                    t={t}
                    isOrderScreen={isOrderScreen}
                    isOrderDetailTab={isOrderDetailTab}
                    expandedProducts={expandedProducts}
                    expandedProductsItemList={expandedProductsItemList}
                    toggleProduct={toggleProduct}
                    toggleProductItemList={toggleProductItemList}
                    isEquityTemplate={isEquityTemplate}
                    orderType={orderType}
                    showCheckBox={showCheckBox}
                    isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                    isEquityTemp={isEquityTemp}
                    handleSetItemClick={handleSetItemClick}
                    removeCounter={removeCounter}
                    addCounter={addCounter}
                    isFromSurgeryTemplate={isFromSurgeryTemplate}
                    isTemplateDetail={isTemplateDetail}
                    isEquity={isEquity}
                    handleLocationChange={handleLocationChange}
                    inventoryShipping={inventoryShipping}
                    handleSetSelection={handleSetSelection}
                    isReviewSubmitScreen={isReviewSubmitScreen}
                    updateProductQuantity={updateProductQuantity}
                    deleteProduct={deleteProduct}
                    isConsignmentAdd={isConsignmentAdd}
                    marginRight={marginRight}
                />
            )}
        </>
    );
};

export default CondensedMobileViewList;
